import { useContext } from 'react';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { TEDEKBokforderSTATUSEnum } from '../../../../../../globalQueryTypes';
import clientAvenyModel from '../../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import { IAssociationListConfig } from '../../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import {
  BusinessCollectionMenuItemHookType,
  defaultBusinessCollectionMenuItem,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionMenu/Utils/BusinessCollectionMenuUtils';
import {
  ActionTransformer,
  BusinessDataFormContext,
  IBusinessDataFormContext,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { BokforderQuery_node_TEDEKBokforder__Associations_Rader } from '../Queries/_QueryTypes/BokforderQuery';
import BokforderContext from '../Components/BokforderContext/BokforderContext';

const useAddDokumentBusinessCollectionMenuItem: BusinessCollectionMenuItemHookType =
  () => {
    const bokforderContext = useContext(BokforderContext);
    const formContext = useContext(BusinessDataFormContext);
    const { userID } = useContext(ActiveDatabaseContext);

    const isAttestant = formContext?.data?._Associations?.Rader?.some(
      (row: any) => row?._Associations?.Attestant?.id === userID
    );

    const isBestallare =
      formContext?.data?._Associations?.Bestallare?.id === userID ||
      formContext?.isNew;

    const isKontrollattestant =
      formContext?.data?._Associations?.Kontrollattestant?.id === userID;

    const isInvolved =
      isAttestant ||
      isBestallare ||
      isKontrollattestant ||
      bokforderContext.isReservForAttestant ||
      bokforderContext.isReservForKontrollattestant;

    return {
      ...defaultBusinessCollectionMenuItem.Add,
      isDisabled:
        defaultBusinessCollectionMenuItem.Add?.isDisabled ||
        !isInvolved ||
        formContext?.formState.currentValues?.STATUS ===
          TEDEKBokforderSTATUSEnum.BORTTAGEN,
    };
  };

export const getBokforderDokConfig = (
  formContext: IBusinessDataFormContext<any, unknown>,
  userID: string | null,
  isReservForAttestant: boolean,
  isReservForKontrollattestant: boolean
): IAssociationListConfig => {
  const isAttestant = formContext?.data?._Associations?.Rader?.some(
    (row: any) => row?._Associations?.Attestant?.id === userID
  );

  const isBestallare =
    formContext?.data?._Associations?.Bestallare?.id === userID ||
    formContext?.isNew;

  const isKontrollattestant =
    formContext?.data?._Associations?.Kontrollattestant?.id === userID;

  const isInvolved =
    isAttestant ||
    isBestallare ||
    isKontrollattestant ||
    isReservForAttestant ||
    isReservForKontrollattestant;

  const allowedStatuses = [
    TEDEKBokforderSTATUSEnum.UTKAST,
    TEDEKBokforderSTATUSEnum.EJ_GODKAND,
    TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST,
  ];

  const currentStatus =
    formContext?.formState.currentValues?.STATUS == null && formContext?.isNew
      ? TEDEKBokforderSTATUSEnum.UTKAST
      : formContext?.formState.currentValues?.STATUS;

  return {
    inCard: true,
    defaultVisningstyp: 'lista',
    businessCollectionMenuItems: [useAddDokumentBusinessCollectionMenuItem],
    showDeleteIcon: isInvolved && allowedStatuses.includes(currentStatus),
  };
};

export const bokforderModel: IClientBusinessModel =
  clientAvenyModel.EK.BusinessModels.EKBokforder;

export const bokforderMessageModel: IClientBusinessModel =
  clientAvenyModel.EK.BusinessModels.EKBokforderMeddelande;

export const bokforderActionTransformer: ActionTransformer = (
  action,
  formState
) => {
  const localAction = { ...action };

  if (localAction.type === 'UPDATE') {
    if (
      Object.prototype.hasOwnProperty.call(
        localAction?.customValues ?? {},
        'lastUpdatedBokfOrderRad'
      )
    ) {
      return localAction;
    }

    const updatedRow =
      localAction.value?._Associations?.Rader_Update_Values?.[0] ??
      localAction.value?._Associations?.Rader_Add_Values?.[0];
    // Hanterar om raden redan har kredit/debet
    if (updatedRow?.DEBET != null) {
      const currentRow = formState.currentValues?._Associations?.Rader?.find(
        (row: BokforderQuery_node_TEDEKBokforder__Associations_Rader) =>
          row?.id === updatedRow.id
      );

      if (currentRow?.KREDIT != null) {
        updatedRow.KREDIT = null;
      }
    } else if (updatedRow?.KREDIT != null) {
      const currentRow = formState.currentValues?._Associations?.Rader?.find(
        (row: BokforderQuery_node_TEDEKBokforder__Associations_Rader) =>
          row?.id === updatedRow.id
      );

      if (currentRow?.DEBET != null) {
        updatedRow.DEBET = null;
      }
    }

    if (updatedRow?.id) {
      return {
        ...localAction,
        // Lägger in den senaste redigerade raden i customValues
        customValues: { lastUpdatedBokfOrderRad: updatedRow.id },
      };
    }
  }

  //Använd förgående customValues och lastUpdatedBokfOrderRad.
  return { ...localAction, customValues: formState.customValues };
};
